export var useEntityUrl = function (entity) {
  var _a;
  return entity.url || entity.path || ((_a = entity === null || entity === void 0 ? void 0 : entity.openGraph) === null || _a === void 0 ? void 0 : _a.url);
};